import { Alert } from '@/components';
import { TextMessage } from '@/constant';
import { Fm1_01DefaultInfoUnitActions } from '@/stores';
import { AuthSelectors } from '@/stores/auth/auth.redux';
import { IDataMyPageStore, MyPageActions } from '@/stores/my-page';
import { NOOP, showAlert } from '@/utils';
import { Suspense, useEffect } from 'react';
import { isTablet } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';

import AuthRouter from './auth.router';
import MainRouter from './main.router';

const Router = () => {
	const logged = useSelector(AuthSelectors.selectLogged);

	const dispatch = useDispatch();

	useEffect(() => {
		if (!logged) return;

		dispatch(
			MyPageActions.getDataMyPageRequest({
				callback: ({ data }: { data: IDataMyPageStore }) => {
					if (data?.isWorkerMasterOrSuperRole) {
						dispatch(
							Fm1_01DefaultInfoUnitActions.getDefaultInfoUnitDetailRequest({})
						);
					}
				},
			})
		);
	}, [logged]);

	useEffect(() => {
		const handleOrientationChange = () => {
			const root = document.getElementById('root');
			if (isTablet && root) {
				if (window.orientation === 90 || window.orientation === -90) {
					Alert.hide();
					root.style.display = 'block';
				} else {
					Alert.hide();
					root.style.display = 'none';
					showAlert(TextMessage.ALERT_LANDSCAPE_MODE, NOOP, NOOP, {
						isShowFooter: false,
					});
				}
			}
		};
		handleOrientationChange();
		window.addEventListener('orientationchange', handleOrientationChange);
		return () => {
			window.removeEventListener('orientationchange', handleOrientationChange);
		};
	}, []);

	return (
		<Suspense fallback={<div className="d-none" />}>
			{logged ? <MainRouter /> : <AuthRouter />}
		</Suspense>
	);
};

export default Router;
